export default __webpack_public_path__ + "static/media/section-about-img-3.fa21e6e5.png";